export const imAuthRootPath = '/'
export const imAuthUiPath = '/imauth/ui/'
export const updatePassWord = imAuthUiPath + 'update-password'
export const forgotPassWord = imAuthUiPath + 'forgot-password'
export const forgotUserName = imAuthUiPath + 'forgot-username'
export const password = imAuthUiPath + 'password'
export const expired = imAuthUiPath + 'expired'
export const twoFactorSetup = imAuthUiPath + 'two-factor-setup'
export const login = imAuthUiPath + 'login'
export const verifyOtp = imAuthUiPath + 'verify-otp'
export const accountLinking = imAuthUiPath + 'account-linking'
export const accountCreate = imAuthUiPath + 'create-account'
export const joinAccount = imAuthUiPath + 'join-account'
export const userLinking = imAuthUiPath + 'user-linking'
export const logout = imAuthUiPath + 'logout'